import React from "react";
import { getL1SheetProperty, setLevel2Properties } from "../WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardCustomizationFlieds } from "./ControlPanel";
import SelectColor from "../components/Aside2Components/CustomizeComponent/SelectColor";
import { ToggleWithTitle } from "../../../components/BasicComponents/ToggleWithTitle";

export default function Format({ currentSheetId }) {
  const dispatch = useDispatch();

  const dispatchItemToredux = (value, reduxKey) => {
    dispatch(
      setLevel2Properties({
        reduxKey,
        Sheetid: currentSheetId,
        parentKey: "customization",
        value,
        itemInArray: false,
      })
    );
  };
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, currentSheetId, "customization")
  );
  return (
    <div className="space-y-4">
      {getDashboardCustomizationFlieds.map((item) => {
        const { type, reduxKey, title, defaultValue, isParent, colorType } =
          item;

        if (type === "color") {
          return (
            <SelectColor
              ControllerProps={item}
              dispatchItemToredux={dispatchItemToredux}
              color={
                customizationObject
                  ? customizationObject[reduxKey]
                  : defaultValue
              }
              defaultValue={defaultValue}
              colorType={colorType}
            />
          );
        }

        if (type === "checkbox") {
          return (
            <ToggleWithTitle
              {...{
                title,
                dispatchItemToredux,
                defaultValue,
                reduxKey,
                isParent,
              }}
            />
          );
        }

        return null;
      })}
    </div>
  );
}
